/** Maximum character count for a task title. */
export var TITLE_MAX_LENGTH = 50;

/** Maximum character count for a task description, matching the backend limit. */
export var CONTEXT_MAX_LENGTH = 1000;

/** Blank form state used when the create-task panel first opens. */
export var INITIAL_FORM_STATE = {
  title: "",
  context: "",
  remindAfter: "",
  ownedBy: null,
  labelId: null,
  linkedResources: {
    reports: [],
    appointments: [],
    encounters: []
  }
};

/** Converts the local form state into the shape expected by the create reminder API. */
export function buildCreatePayload(formState) {
  var remindAfter = /^\d{4}-\d{2}-\d{2}$/.test(formState.remindAfter) ? "".concat(formState.remindAfter, "T00:00:00.000Z") : formState.remindAfter;
  return {
    title: formState.title.trim(),
    context: formState.context.trim(),
    remind_after: remindAfter,
    owned_by: formState.ownedBy ? parseInt(formState.ownedBy, 10) : null,
    label_ids: formState.labelId ? [parseInt(formState.labelId, 10)] : [],
    linked_resources: formState.linkedResources
  };
}